import React, { FC } from 'react';
import * as StyledRichTextAndIconBoxes from './richTextAndIconBoxes.styles';
import ICtaIconBox from '../../../interfaces/elements/ctaIconBox';
import { Columns, Column } from '../../base/grid';
import { StyledRichText } from '../../base/richTextStyleWrapper/richTextStyleWrapper';
import CtaIconBox from '../ctaIconBox';

interface Props {
	content: string;
	boxes: ICtaIconBox[];
}

const RichTextAndIconBoxes: FC<Props> = ({ content, boxes }) => {
	return (
		<StyledRichTextAndIconBoxes.Wrapper>
			<Columns>
				<Column tablet={2 / 3}>
					<StyledRichTextAndIconBoxes.ContentWrapper>
						<StyledRichText content={content} />
					</StyledRichTextAndIconBoxes.ContentWrapper>
				</Column>
				<Column tablet={1 / 3}>
					{boxes.map((box, index) => (
						<StyledRichTextAndIconBoxes.IconBoxWrapper key={index}>
							<CtaIconBox box={box} />
						</StyledRichTextAndIconBoxes.IconBoxWrapper>
					))}
				</Column>
			</Columns>
		</StyledRichTextAndIconBoxes.Wrapper>
	);
};

export default RichTextAndIconBoxes;
